// Libs
import React from "react";
import { Card } from "antd";

// Styles
import s from "./index.module.scss";

// Contents
import DashboardContentsFirewallDestinationHistory from "components/contents/dashboard/firewall-history";

function DashboardFirewallDestinationHistory() {
  return (
    <>
      <Card className={s.container}>
        <section className={s.section}>
          <DashboardContentsFirewallDestinationHistory />
        </section>
      </Card>
    </>
  );
}

export default DashboardFirewallDestinationHistory;
